module.exports = __webpack_public_path__ + "img/zeitstrahl_punkte_vertikal.330abda6.svg";